import { AutocompleteInput, SaveButton } from "@/components/admin";
import { Card } from "@/components/ui/card";
import { WalletCards } from "lucide-react";
import {
  Create,
  DateInput,
  NumberInput,
  ReferenceInput,
  SimpleForm,
} from "../../common";

const StructureToolbar = () => (
  <div className="form-toolbar-premium">
    <SaveButton className="btn-green-action" label="Save Structure" />
  </div>
);

export const SalaryStructureCreate = () => (
  <Create title="Create Salary Structure">
    <Card className="form-container">
      <div className="form-header-premium">
        <WalletCards className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">New Salary Structure</h2>
      </div>
      <SimpleForm toolbar={<StructureToolbar />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <ReferenceInput source="employee_id" reference="employees">
            <AutocompleteInput label="Employee" optionText="name" />
          </ReferenceInput>
          <ReferenceInput source="component_id" reference="hr_payroll_components">
            <AutocompleteInput label="Component" optionText="name" />
          </ReferenceInput>
          <NumberInput source="amount" label="Amount / Percentage" />
          <DateInput source="effective_from" label="Effective From" />
        </div>
      </SimpleForm>
    </Card>
  </Create>
);
